<template>
  <div>
    <line-chart
      :chart-data="chartData"
      :title="$t('smi_sri.individual_ielts')"
      v-if="chartData"
    ></line-chart>
  </div>
</template>

<script>
import { COLOR_CHART_IELTS } from "@/helpers/color-chart-config";
import LineChart from "@/components/Base/LineChart";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  components: {
    LineChart
  },
  props: ["dataDetail"],
  data() {
    return {
      chartData: {}
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      const datasetsChart = [];
      this.dataDetail.chartData.map(item => {
        if (item.label !== "Average score") {
          datasetsChart.push({
            ...item,
            borderColor: COLOR_CHART_IELTS[item.label],
            backgroundColor: "transparent",
            borderDash: item.label === "Overall" ? [0, 0] : [5, 5],
            borderWidth: item.label === "Overall" ? 2 : 1,
            pointRadius: 1,
            tension: 0
          });
        } else {
          datasetsChart.push({
            ...item,
            borderColor: "transparent",
            backgroundColor: "#B8E7BA33",
            pointRadius: 1,
            tension: 0
          });
        }
      });

      const prefixTooltips = [];
      this.dataDetail.test_name.map((name, index) => {
        prefixTooltips.push(
          `${name} (${convertDateFromServer(
            this.dataDetail.test_date[index],
            "date"
          )})`
        );
      });

      this.chartData = {
        labels: this.dataDetail.test_name,
        datasets: datasetsChart,
        prefix: prefixTooltips
      };
    }
  }
};
</script>
